import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, ArrowUpRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_a2ff0632-ba58-4eba-8778-120ca1681ddb/artifacts/ft9gjhxd_franchise_india_knowledge_company_logo%20%281%29.jpeg";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white noise-overlay">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="bg-white inline-flex p-3 rounded-sm">
              <img src={LOGO} alt="FIKS" className="h-12 w-auto object-contain" />
            </div>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              The world's only franchise consultancy focused exclusively on
              knowledge-based businesses — helping brands become franchise-ready
              and scale across global markets.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.25em] text-gold font-semibold">
              A Franchise India Group Company
            </p>
            <div className="mt-4 bg-white inline-flex px-4 py-3 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_franchise-asia/artifacts/lg6jivtt_logos%20%281%29.webp"
                alt="Franchise India — Ideas For Tomorrow"
                className="h-9 w-auto object-contain"
              />
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-sm uppercase tracking-[0.2em] text-white/50 font-semibold mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/services", label: "Our Services" },
                { to: "/brands", label: "Brands We Represent" },
                { to: "/team", label: "Our Team" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Get In Touch" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/70 hover:text-gold transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm uppercase tracking-[0.2em] text-white/50 font-semibold mb-6">
              Connect
            </h4>
            <a
              href="mailto:satyam.garg@franglobal.com"
              data-testid="footer-email"
              className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors duration-200 mb-4"
            >
              <Mail size={18} />
              <span className="break-all text-sm">Email Us</span>
            </a>
            <a
              href="tel:+918376849548"
              data-testid="footer-phone"
              className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors duration-200 mb-4"
            >
              <Phone size={18} />
              <span className="text-sm">+91-8376849548</span>
            </a>
            <a
              href="https://www.linkedin.com/company/franchiseindiaknowledgeservices/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors duration-200"
            >
              <Linkedin size={18} />
              <span className="text-sm">LinkedIn</span>
              <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Franchise India Knowledge Services. All rights reserved.</p>
          <p>Coaching &amp; Consulting · Child Experience · Franchise Consulting · Sports Education</p>
        </div>
      </div>
    </footer>
  );
};
